import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M19.358 12.5218L12.6927 12.0011C12.6367 11.9971 12.582 12.0065 12.5314 12.0288L6.53135 14.6955C6.37468 14.7651 6.29635 14.9425 6.35068 15.1055L6.64368 15.9851C6.91268 16.7915 7.63002 17.3811 8.47168 17.4875C9.98835 17.6791 12.81 18.0001 14.6667 18.0001C16.0167 18.0001 17.2713 17.4841 18.1993 16.5471C19.1583 15.5788 19.679 14.2661 19.6653 12.8511C19.6637 12.6785 19.5303 12.5355 19.358 12.5218Z',
                    fill: '#F3C7A8',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M12.0002 11.0002H4.66683C4.48283 11.0002 4.3335 10.8508 4.3335 10.6668C4.3335 10.4828 4.48283 10.3335 4.66683 10.3335H12.0002C12.1842 10.3335 12.3335 10.4828 12.3335 10.6668C12.3335 10.8508 12.1842 11.0002 12.0002 11.0002Z',
                    fill: '#444444',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M10.0285 9.33341H4.66683C4.48283 9.33341 4.3335 9.18408 4.3335 9.00008C4.3335 8.81608 4.48283 8.66675 4.66683 8.66675H10.0285C10.2125 8.66675 10.3618 8.81608 10.3618 9.00008C10.3618 9.18408 10.2128 9.33341 10.0285 9.33341Z',
                    fill: '#444444',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M14.3335 7H5.00016C4.63183 7 4.3335 7.29833 4.3335 7.66667V14.3333C4.3335 14.7017 4.63183 15 5.00016 15H14.3335C14.7018 15 15.0002 14.7017 15.0002 14.3333V7.66667C15.0002 7.29833 14.7018 7 14.3335 7Z',
                    fill: '#43A6DD',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M14.6668 8.66675H4.3335V10.3334H14.6668V8.66675Z',
                    fill: '#223E49',
                },
            },
            {
                tag: 'path',
                attr: {
                    opacity: '0.1',
                    d: 'M15.0003 8.68341C14.8897 8.67608 14.7793 8.66675 14.667 8.66675H10.0003C9.81633 8.66675 9.66699 8.81608 9.66699 9.00008C9.66699 10.1031 10.564 11.0001 11.667 11.0001H12.667C12.7943 12.1501 13.9147 13.3224 15.0003 13.7884V8.68341Z',
                    fill: 'black',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M14.667 8H10.0003C9.81633 8 9.66699 8.14933 9.66699 8.33333C9.66699 9.43633 10.564 10.3333 11.667 10.3333H13.019C13.1827 11.812 14.4037 13.3333 16.0003 13.3333C16.0053 13.3333 16.01 13.3333 16.015 13.333L19.347 13.187C19.5263 13.1793 19.6673 13.0303 19.6657 12.8507C19.6397 10.176 17.3973 8 14.667 8Z',
                    fill: '#F3C7A8',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M10.3337 11.6667H5.66699V12.6667H10.3337V11.6667Z',
                    fill: 'white',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: false })) })));
};
const PaymentColored = React.forwardRef(IconComponent);
PaymentColored.displayName = 'PaymentColored';

export { PaymentColored };
